<template>
    <v-app :class="instanceName">
        <!-- <template v-if="!authenticated">
            <LogInView />
        </template>

        <template v-else> -->
        <template v-if="showHeader">
            <v-navigation-drawer
                v-model="drawer"
                :mini-variant.sync="mini"
                :expand-on-hover="isMini"
                permanent
                app
                light
                color="white"
                width="300"
                :aclipped="$vuetify.breakpoint.lgAndUp"
                class="appnavbar"
            >
                <div class="d-flex align-center justify-center elevation-4" style="background: #2b3848; height: 64px">
                    <!-- replace -->
                    <v-btn v-if="mini" dark icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                    <div v-else class="d-flex align-center">
                        <!-- <v-img alt="Logo" contain max-width="256" :src="require('./assets/ib3-logo.png')" transition="scale-transition" height="32" style="filter: invert(0%)" /> -->
                        <template v-if="instanceName === 'pre'">
                            <span class="text-h6 red white--text px-1 py-0 rounded mr-2">PRE</span>
                            <v-img alt="Logo" contain max-width="156" :src="require('./assets/ib3-logo.png')" transition="scale-transition" height="32" />
                        </template>
                        <template v-else-if="instanceName === 'palmaaquarium'">
                            <v-img alt="Logo" contain max-width="192" :src="require('./assets/ib3-logo.png')" transition="scale-transition" height="32" style="filter: invert(0%)" />
                            <v-img alt="Logo" contain amax-height="32" max-width="48" :src="require('./assets/palmaaquarium-logo.png')" transition="scale-transition" height="48" class="rounded-xl" />
                        </template>
                        <!-- <template v-else-if="instanceName === 'aspro'">
                            <v-img alt="Logo" contain max-width="192" :src="require('./assets/ib3-logo.png')" transition="scale-transition" height="32" style="filter: invert(0%)" />
                            <v-img
                                alt="Logo"
                                contain
                                amax-height="32"
                                max-width="32"
                                :src="require('./assets/aspro-logo.png')"
                                transition="scale-transition"
                                height="28"
                                style="margin-top: 1px; margin-left: 8px"
                            />
                        </template> -->
                        <template v-else>
                            <v-img alt="Logo" contain max-width="256" :src="require('./assets/ib3-logo.png')" transition="scale-transition" height="32" style="filter: invert(0%)" />
                        </template>
                        <v-btn icon dark @click.stop="mini = !mini" class="mr-a2">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                    </div>
                </div>

                <perfect-scrollbar v-if="!mini" ref="scroll" :watchOptions="true">
                    <!-- AVATAR -->
                    <div class="d-flex flex-column align-center justify-center mt-2">
                        <div @click="showUserPanel" class="px-4 d-flex align-center justify-center text-body-2" style="width: 100%; height: 64px; cursor: pointer" v-ripple="{ center: true }">
                            <v-avatar v-if="userAvatar" size="56">
                                <v-img :src="userAvatar" />
                            </v-avatar>
                            <v-avatar v-else color="blue darken-4" size="56">
                                <span class="white--text text-h5">{{ userInitials }}</span>
                            </v-avatar>
                            <div class="d-flex align-center">
                                <div class="d-flex flex-column ml-4">
                                    <span class="text-subtitle-1 font-weight-bold text-center">{{ userName }}</span>
                                    <span class="text-subtitle-2 text-center">{{ userPhone }}</span>
                                </div>
                                <v-icon v-if="userPanelVisible" class="mx-2">mdi-chevron-up</v-icon>
                                <v-icon v-else class="mx-2">mdi-chevron-down</v-icon>

                                <v-icon v-if="timeRecordForCurrentUser && timeRecordForCurrentUser.overflowed" class="blink" color="red">mdi-alert-outline</v-icon>
                            </div>
                        </div>
                        <div v-if="userPanelVisible" class="mx-auto text-center d-flex flex-column align-center" style="width: 100%">
                            <template v-if="timeRecordForCurrentUser !== null">
                                <template v-if="timeRecordForCurrentUser.needToStart">
                                    <div class="d-flex align-center">
                                        <v-btn small icon color="primary" class="mt-2" @click="startTimeRecord" :disabled="!timeRecordForCurrentUser.canStart">
                                            <v-icon>mdi-play</v-icon>
                                        </v-btn>
                                        <v-btn small icon color="primary" class="mt-2" @click="pauseTimeRecord" :disabled="!timeRecordForCurrentUser.canEnd">
                                            <v-icon>mdi-pause</v-icon>
                                        </v-btn>
                                        <v-btn small icon color="primary" class="mt-2" @click="endTimeRecord" :disabled="!timeRecordForCurrentUser.canEnd">
                                            <v-icon>mdi-stop</v-icon>
                                        </v-btn>
                                    </div>
                                    <span class="text-body-2">No has iniciado la jornada de hoy</span>
                                </template>
                                <template v-else>
                                    <div class="d-flex align-center">
                                        <v-btn small icon color="primary" class="mt-2" @click="startTimeRecord" :disabled="!timeRecordForCurrentUser.canStart">
                                            <v-icon>mdi-play</v-icon>
                                        </v-btn>
                                        <v-btn small icon color="primary" class="mt-2" @click="pauseTimeRecord" :disabled="!timeRecordForCurrentUser.canEnd">
                                            <v-icon>mdi-pause</v-icon>
                                        </v-btn>
                                        <v-btn small icon color="primary" class="mt-2" @click="endTimeRecord" :disabled="!timeRecordForCurrentUser.canEnd">
                                            <v-icon>mdi-stop</v-icon>
                                        </v-btn>
                                    </div>
                                    <span class="text-body-2">Jornada: {{ timeRecordForCurrentUser.readableWorkTime }}</span>
                                </template>
                            </template>

                            <v-divider class="my-3" style="width: 100%"></v-divider>
                            <v-btn v-if="isEmployee" small text @click="myDocumentation()" style="width: 256px">Ver mi perfil y documentación</v-btn>
                            <v-btn small color="red" text @click="logOut()" style="width: 256px">Cerrar sesión</v-btn>
                        </div>
                    </div>

                    <!-- NAVIGATION -->
                    <v-list dense v-if="sitesLoaded" expand>
                        <v-divider></v-divider>
                        <template v-for="(section, z) in resolvedSections">
                            <template v-if="section.showName">
                                <v-subheader :key="`header-${z}`">{{ section.name }}</v-subheader>
                            </template>

                            <template v-for="(group, i) in section.groups">
                                <v-list-group v-if="!group.url" :key="`group-${z}-${i}`" :group="group.group">
                                    <template v-slot:activator>
                                        <v-list-item-icon class="min-width:16px; width:16px">
                                            <v-icon class="ma-0 pa-0">{{ group.icon }}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>{{ group.name }}</v-list-item-title>
                                    </template>

                                    <template v-for="(item, j) in group.items">
                                        <v-list-item v-if="!item.items" :key="`item-${z}-${i}-${j}`" :to="item.url" class="ml-7">
                                            <v-list-item-icon>
                                                <v-icon>{{ item.icon }}</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="text-wrap">
                                                    {{ item.name }}
                                                    <v-icon v-if="item.permission === 'superuser'" small class="ml-2" color="grey lighten-2">mdi-shield-account</v-icon>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                        <v-list-group v-else :key="`group-${z}-${i}-${j}`" :group="item.group" :value="item.name" sub-group>
                                            <template v-slot:activator>
                                                <v-list-item-title>{{ item.name }}</v-list-item-title>
                                            </template>
                                            <v-list-item v-for="(subitem, k) in item.items" :key="`item-${z}-${i}-${j}-${k}`" :to="subitem.url" class="ml-7">
                                                <v-list-item-icon>
                                                    <v-icon>{{ subitem.icon }}</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title class="text-wrap">
                                                        {{ subitem.name }}
                                                        <v-icon v-if="subitem.permission === 'superuser'" small class="ml-2" color="grey lighten-2">mdi-shield-account</v-icon>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-group>
                                    </template>
                                </v-list-group>
                                <v-list-item v-else :key="i" :to="group.url">
                                    <v-list-item-icon>
                                        <v-icon>{{ group.icon }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="text-wrap">{{ group.name }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </template>
                    </v-list>
                </perfect-scrollbar>
            </v-navigation-drawer>
        </template>
        <v-main>
            <perfect-scrollbar ref="routerScroll" :watchOptions="true">
                <!-- <router-view :key="$route.fullPath"/> -->
                <router-view />
            </perfect-scrollbar>
        </v-main>

        <v-snackbar v-model="toastVisible" multi-line timeout="3000" elevation="4" :color="toast.color || 'green'">
            <div class="d-flex flex-column">
                <span v-html="toast.title"></span>
                <span v-if="toast.message" class="text-caption" v-html="toast.message"></span>
            </div>
            <template v-if="toast.buttonText" v-slot:action="{ attrs }">
                <v-btn :color="toast.buttonColor || 'black'" text v-bind="attrs" @click="clickToast">
                    <v-icon v-if="toast.buttonIcon" class="mr-2">{{ toast.buttonIcon }}</v-icon>
                    {{ toast.buttonText }}
                </v-btn>
            </template>
        </v-snackbar>

        <!-- GLOBAL DIALOGS -->
        <GalleryDialog />
        <ContentElementsDialog />
        <GetMeetingPointInMapDialogVue />
        <GlobalConfirmationDialog />
        <GlobalSelectionDialog />
        <CrmDialog />
        <BookingContextMenu />
        <CommandCenterDialog />
        <ProgressDialog />
        <LogViewerDialog />
    </v-app>
</template>

<script lang="ts">
import { mapState } from "pinia";
import { Component, Vue, Watch } from "vue-property-decorator";
import { loginStore } from "./stores/LoginStore";
import { errorStore } from "./stores/ErrorStore";
import { BaseView } from "@/components/BaseView";
// import { MailboxService, MailboxSummary } from "./services/MailboxService";
import { EventBus } from "@/components/EventBus";

import { DataClient, ToastRequest } from "@/services/DataClient";

import LogInView from "./views/Users/LogInView.vue";
import GalleryDialog from "./views/Images/GalleryDialog.vue";
import ContentElementsDialog from "./views/ContentElements/ContentElementsDialog.vue";
import GetMeetingPointInMapDialogVue from "@/views/MeetingPoints/GetMeetingPointInMapDialog.vue";
import GlobalConfirmationDialog from "@/components/Dialogs/GlobalConfirmationDialog.vue";
import GlobalSelectionDialog from "@/components/Dialogs/GlobalSelectionDialog.vue";
import BookingContextMenu from "@/components/Dialogs/BookingContextMenu.vue";
import CommandCenterDialog from "@/views/CommandCenter/CommandCenterDialog.vue";
import ProgressDialog from "@/components/Dialogs/ProgressDialog.vue";
import { GetTimeRecordForCurrentUserResponse, LogUserInResponse } from "@/services/ClientInterfaces";
import CrmDialog from "@/views/Crm/CrmDialog.vue";
import LogViewerDialog from "@/views/Logs/LogViewerDialog.vue";
import { Section, Group, sections } from "@/services/Navigation";
import { Utilities } from "@/services/Utilities";

// interface Section {
//     name: string;
//     groups: Group[];
// }

// interface Group {
//     name: string;
//     icon: string;

//     group?: string | RegExp;

//     items?: Group[];
//     permission?: string;
//     url?: any;
// }

// interface Item {
//     name: string;
//     icon: string;
//     permission: string;
//     url: any;
// }

@Component({
    components: {
        LogInView,
        GalleryDialog,
        ContentElementsDialog,
        GetMeetingPointInMapDialogVue,
        GlobalConfirmationDialog,
        CrmDialog,
        BookingContextMenu,
        CommandCenterDialog,
        ProgressDialog,
        LogViewerDialog,
        GlobalSelectionDialog,
    },
    computed: {
        ...mapState(loginStore, ["authenticated", "details"]),
        ...mapState(errorStore, ["error"]),
    },
})
export default class extends BaseView {
    authenticated!: boolean;
    details!: LogUserInResponse;
    error!: string;

    drawer = true;
    mini = this.isMini;
    collapsed = false;

    sitesLoaded = false;

    mailboxTimestamp = 0;
    bookingsTimestamp = 0;
    lastPhone = "";

    toastVisible = false;
    toast: ToastRequest = {} as ToastRequest;

    userPanelVisible = false;

    timeRecordForCurrentUser: GetTimeRecordForCurrentUserResponse | null = null;
    timeRecordDialog = false;

    checkPermission(requested: string, available: string[]): boolean {
        if (!requested) {
            return true;
        }

        if (!available) {
            return false;
        }

        const isLocalEnvironment = window.location.hostname.includes("localhost");
        const isSuperUser = this.details?.isSuperUser || false;
        const requestedPermissions = requested.split(",");

        for (const p of requestedPermissions) {
            if (p === "local") {
                return isLocalEnvironment;
            }

            if (isSuperUser) {
                return true;
            }

            if (available.includes(p)) {
                return true;
            }
        }

        return false;
    }

    filterGroup(group: Group, permissions: string[]): Group | undefined {
        const result: Group = {
            name: group.name,
            icon: group.icon,
            group: group.group,
            url: group.url,
            permission: group.permission,
            items: [],
        };

        const isSuperUser = this.details?.isSuperUser || false;
        const isMegaUser = isSuperUser && this.details?.name === "Arturo Arévalo";

        // if ((group.permission || "") === "megauser") {
        //     console.log("Checking megauser permission for group " + group.name + ": " + isMegaUser);
        // }

        for (const item of group.items || []) {
            if ((item as any).group) {
                const filteredGroup = this.filterGroup(item as Group, permissions);
                if (filteredGroup?.items?.length) {
                    result.items?.push(filteredGroup);
                }
            } else {
                if (this.checkPermission(item.permission || "", permissions)) {
                    result.items?.push(item);
                }
            }
        }

        if (this.checkPermission(group.permission || "", permissions)) {
            return result;
        } else {
            return undefined;
        }
    }

    get isEmployee() {
        return this.details?.employeeId || false;
    }

    get resolvedSections(): Section[] {
        if (!this.sitesLoaded) {
            return [];
        }

        const license = this.details?.license || "1";
        const permissions = this.details?.permissions || [];

        return sections
            .map((section) => {
                const filteredGroups = section.groups.map((group) => this.filterGroup(group, permissions)!).filter((group) => group && (group?.items?.length || group?.url));

                return {
                    name: section.name,
                    showName: section.showName,
                    groups: filteredGroups,
                    licenses: section.licenses,
                };
            })
            .filter((section) => section.groups.length > 0);
        //.filter((section) => section.licenses.includes(license));
    }

    get userName() {
        return this.details?.name || "";
    }

    get userPhone() {
        return this.details?.phoneNumber || "";
    }

    get userAvatar() {
        if (!this.details?.imageId) {
            return "";
        }

        return `/uploads/${this.details.imageId}/64`;
    }

    get userInitials() {
        const name = this.userName;
        if (name) {
            const parts = name.split(" ");
            if (parts.length === 1) {
                return parts[0].substring(0, 2);
            } else {
                return parts[0].substring(0, 1) + parts[parts.length - 1].substring(0, 1);
            }
        }
        return "";
    }
    timer: any;

    get snackbar() {
        return this.error !== "";
    }

    set snackbar(value: boolean) {
        this.closeError();
    }

    async mounted() {
        loginStore().initialize();

        EventBus.$on("scrollToTop", () => this.scrollToTop());
        EventBus.$on("updateScroll", () => this.updateScroll());
        EventBus.$on(DataClient.Dialogs.OpenToastEvent, (event: ToastRequest) => this.openToast(event));

        window.addEventListener("keydown", this.keyUp);

        await this.loadWebSites();

        // this.timer = setInterval(() => this.updateSummary(), 1000);
    }

    destroyed() {
        EventBus.$off(DataClient.Dialogs.OpenToastEvent);

        window.removeEventListener("keydown", this.keyUp);

        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    keyUp(event: KeyboardEvent) {
        if (event.ctrlKey && event.key === "7") {
            event.preventDefault();
            // this.scrollToTop();

            const permissions = this.details?.permissions || [];
            if (this.checkPermission("excursions.bookings.booking-center", permissions)) {
                DataClient.CommandCenter.open({});
            }
        }
    }

    openToast(event: ToastRequest) {
        this.toast = event;
        this.toastVisible = true;
    }

    clickToast() {
        if (this.toast && this.toast.buttonRoute) {
            this.$router.push(this.toast.buttonRoute);
        }

        this.toastVisible = false;
    }

    async loadWebSites() {
        const sites = await DataClient.Websites.getAll();
        const baseSection = sections.find((s) => s.name === "SITIOS WEB");

        if (baseSection) {
            baseSection.groups = sites.map((site) => {
                return {
                    name: (site.name || "").toUpperCase(),
                    icon: "mdi-web",
                    group: new RegExp(`^/websites/${site.id}`),
                    items: [
                        {
                            name: "Configuración",
                            icon: "mdi-web",
                            permission: site.id === "0dc35524-3df1-4f44-884e-7552b1f006c5" ? "superuser" : "websites",
                            url: { name: "GetWebsiteConfiguration", params: { id: site.id } },
                        },
                        {
                            name: "Página de inicio",
                            icon: "mdi-home-outline",
                            // permission: "websites",
                            permission: "superuser",
                            url: { name: "GetWebsiteHomeContent", params: { id: site.id } },
                        },
                        {
                            name: "Fichas de actividad",
                            icon: "mdi-ticket",
                            permission: "websites",
                            url: { name: "GetAllActivitySheets", params: { websiteId: site.id } },
                        },
                        // {
                        //     name: "Páginas",
                        //     icon: "mdi-file-outline",
                        //     permission: "superuser",
                        //     url: { name: "GetAllPages", params: { websiteId: site.id } },
                        // },
                        {
                            name: "Posts",
                            icon: "mdi-post-outline",
                            permission: site.id === "0dc35524-3df1-4f44-884e-7552b1f006c5" ? "superuser" : "websites",
                            url: { name: "GetAllPosts", params: { websiteId: site.id } },
                        },
                    ],
                };
            });
        }

        this.sitesLoaded = true;
    }

    async logOut() {
        if (this.timeRecordForCurrentUser && this.timeRecordForCurrentUser.canEnd) {
            await this.endTimeRecordFromLogOut();
        }

        await DataClient.Users.logOut({});
        loginStore().logOut();

        this.$router.push({ name: "LogIn" });
    }

    closeError() {
        errorStore().hideError();
    }

    searchBookingsByPhone(phone: string) {
        this.$router.push({
            name: "booking-center",
            query: { search: `+${phone}` },
        });
    }

    @Watch("details", { immediate: false })
    async userDetailsChanged() {
        if (this.details) {
            await this.refreshTimeRecords();

            if (this.timeRecordForCurrentUser?.needToStart) {
                setTimeout(() => {
                    this.startTimeRecord();
                }, 1000);
            }
        }
    }

    async refreshTimeRecords() {
        if (this.details?.timeRecordEnabled) {
            this.timeRecordForCurrentUser = await DataClient.TimeRecords.getForCurrentUser();
        } else {
            this.timeRecordForCurrentUser = null;
        }
    }

    async startTimeRecord() {
        await this.refreshTimeRecords();

        if (!this.timeRecordForCurrentUser) {
            return;
        }

        const date = Utilities.formatDateToDDMMYYYY(this.timeRecordForCurrentUser.date);

        const yes = await DataClient.Dialogs.confirmation({
            title: "Control de jornada laboral " + date,
            message: `<strong>¿Comenzar la jornada laboral del ${date} ahora?</strong>`,
            messages: ["El registro de jornada laboral es obligatorio. Puedes posponerlo, pero no olvides iniciar tu jornada laboral más adelante."],
            icon: "mdi-clock-in",
            acceptButtonText: "Sí, iniciar jornada laboral",
            cancelButtonText: "No, lo haré más adelante",
            cancelButtonColor: "red",
            persistent: true,
        });

        if (yes) {
            this.timeRecordForCurrentUser = await DataClient.TimeRecords.startForCurrentUser({});
        }
    }

    async resumeTimeRecord() {
        await this.refreshTimeRecords();

        if (!this.timeRecordForCurrentUser) {
            return;
        }

        const date = Utilities.formatDateToDDMMYYYY(this.timeRecordForCurrentUser.date);

        const yes = await DataClient.Dialogs.confirmation({
            title: "Control de jornada laboral " + date,
            message: `<strong>¿Desea reanudar la jornada laboral del ${date} ahora?</strong>`,
            messages: [
                "A continuación se muestran los periodos contabilizados en su jornada hasta el momento.",
                ...this.timeRecordForCurrentUser.periods.map((period) => `${period.start} - ${period.end} (${period.readableDuration})`),
            ],
            icon: "mdi-clock-in",
            acceptButtonText: "Sí, reanudar jornada laboral",
            cancelButtonText: "No, cancelar",
            cancelButtonColor: "red",
            persistent: true,
        });

        if (yes) {
            this.timeRecordForCurrentUser = await DataClient.TimeRecords.startForCurrentUser({});
        }
    }

    async pauseTimeRecord() {
        await this.refreshTimeRecords();

        if (!this.timeRecordForCurrentUser) {
            return;
        }

        const date = Utilities.formatDateToDDMMYYYY(this.timeRecordForCurrentUser.date);
        const yes = await DataClient.Dialogs.confirmation({
            title: "Control de jornada laboral " + date,
            message: `<strong>¿Desea pausar la jornada laboral del ${date} ahora?</strong>`,
            messages: [
                "A continuación se muestran los periodos contabilizados en su jornada hasta el momento.",
                ...this.timeRecordForCurrentUser.periods.map((period) => `${period.start} - ${period.end || "Hasta ahora"} (${period.readableDuration})`),
            ],
            icon: "mdi-clock-out",
            acceptButtonText: "Sí, pausar jornada laboral",
            cancelButtonText: "No, cancelar",
            cancelButtonColor: "red",
            persistent: true,
        });

        if (yes) {
            this.timeRecordForCurrentUser = await DataClient.TimeRecords.endForCurrentUser({ pause: true });
        }
    }

    async endTimeRecord() {
        await this.refreshTimeRecords();

        if (!this.timeRecordForCurrentUser) {
            return;
        }

        const date = Utilities.formatDateToDDMMYYYY(this.timeRecordForCurrentUser.date);
        const yes = await DataClient.Dialogs.confirmation({
            title: "Control de jornada laboral " + date,
            message: `<strong>¿Desea finalizar la jornada laboral del ${date} ahora?</strong>`,
            messages: [
                "A continuación se muestran los periodos contabilizados en su jornada hasta el momento.",
                ...this.timeRecordForCurrentUser.periods.map((period) => `${period.start} - ${period.end || "Hasta ahora"} (${period.readableDuration})`),
            ],
            icon: "mdi-clock-out",
            acceptButtonText: "Sí, finalizar jornada laboral",
            cancelButtonText: "No, lo haré más adelante",
            cancelButtonColor: "red",
            persistent: true,
        });

        if (yes) {
            this.timeRecordForCurrentUser = await DataClient.TimeRecords.endForCurrentUser({});
        }
    }
    async endTimeRecordFromLogOut() {
        await this.refreshTimeRecords();

        if (!this.timeRecordForCurrentUser) {
            return;
        }

        const date = Utilities.formatDateToDDMMYYYY(this.timeRecordForCurrentUser.date);
        const yes = await DataClient.Dialogs.confirmation({
            title: "Control de jornada laboral " + date,
            message: `<strong>¿Desea finalizar la jornada laboral del ${date} al desconectar su sesión?</strong>`,
            messages: [
                "A continuación se muestran los periodos contabilizados en su jornada hasta el momento.",
                ...this.timeRecordForCurrentUser.periods.map((period) => `${period.start} - ${period.end || "Hasta ahora"} (${period.readableDuration})`),
            ],
            icon: "mdi-clock-out",
            acceptButtonText: "Sí, finalizar jornada y desconectar",
            cancelButtonText: "No, sólo desconectar",
            cancelButtonColor: "red",
            persistent: true,
        });

        if (yes) {
            this.timeRecordForCurrentUser = await DataClient.TimeRecords.endForCurrentUser({});
        }
    }

    showUserPanel() {
        this.refreshTimeRecords();
        this.userPanelVisible = !this.userPanelVisible;
    }

    @Watch("$route")
    async scrollToTop() {
        // Scroll the main content area back to the top on navigation
        const ref = (this.$refs as any).routerScroll as any;
        if (ref && ref.$el && ref.$el.scrollTop) {
            ref.$el.scrollTop = 0;
            this.updateScroll();
        }

        // Scroll the navigation sidebar to bring the active item into view
        await this.$nextTick();
        const navRef = (this.$refs as any).scroll as any;
        if (navRef && navRef.$el) {
            const activeItem = navRef.$el.querySelector(".v-list-item--active");
            if (activeItem) {
                activeItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
            this.updateScroll2();
        }
    }

    updateScroll() {
        const ref = (this.$refs as any).routerScroll as any;

        setTimeout(() => {
            ref.update();
        }, 100);
    }

    updateScroll2() {
        const ref = (this.$refs as any).scroll as any;

        setTimeout(() => {
            ref.update();
        }, 100);
    }

    get isMini(): boolean {
        return this.$vuetify.breakpoint.width <= 1350;
        // return this.$vuetify.breakpoint.mdAndDown;
    }

    get showHeader() {
        if (this.$route.meta?.hideHeader) {
            return false;
        }

        if (!this.authenticated) {
            return false;
        }

        return true;
    }

    // @Watch("$vuetify.breakpoint.mdAndDown")
    // onBreakpointChange(newValue: boolean) {
    //     if (!newValue) {
    //         this.mini = false;
    //     }
    // }

    @Watch("$vuetify.breakpoint.width")
    onBreakpointChange(newValue: number) {
        if (newValue <= 1350) {
            this.mini = true;
        } else {
            this.mini = false;
        }
    }

    myDocumentation() {
        this.$router.push({
            name: "ViewEmployee",
            params: { id: "me" },
        });
    }
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");
@import url("https://fonts.googleapis.com/css?family=Open Sans&display=swap");
@import url("https://fonts.googleapis.com/css?family=Lato&display=swap");

.appnavbar {
    .ps {
        height: calc(100vh - 64px);
    }
}

.ps {
    height: calc(100vh - 0px);
}

.ps__rail-y {
    z-index: 2;
}

.blink {
    animation: blinker 1s linear infinite;
}

@keyframes blinker {
    50% {
        opacity: 0.25;
    }
}

.fixed-sub-bar {
    position: sticky !important;
    position: -webkit-sticky !important; /* for Safari */
    top: 128px !important;
    width: 100% !important;
    z-index: 1 !important;
}

.ellipsis {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
}

.keep-spacing {
    white-space: pre-wrap !important;
}

/* hide the "scrim", it's pointless */
.v-overlay--active .v-overlay__scrim {
    display: none;
}
/* style the overlay container as required */
.v-overlay--active {
    backdrop-filter: blur(2px);
    background: rgb(0 0 0 / 0.2);
}
/* if you have an auto dark theme
   for prefers-color-scheme: dark
   I find the 0.8 too dark
*/
@media (prefers-color-scheme: dark) {
    .v-overlay--active {
        background: rgb(0 0 0 / 0.4);
    }
}

.scrollbox {
    overflow-y: scroll;

    &::-webkit-scrollbar {
        background-color: transparent;
        width: 8px;
    }
}
.scrollbox:hover {
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
    }
}
@media (hover: none) {
    .scrollbox {
        &::-webkit-scrollbar {
            width: 8px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0.2);
        }
    }
}

.scrollbox2 {
    overflow-y: overlay !important;
    overflow-x: hidden !important;

    &::-webkit-scrollbar {
        display: block;
        width: 8px;
    }

    &::-webkit-scrollbar-button {
        display: none;
    }

    &::-webkit-scrollbar-track {
        background-color: #00000000;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: #00000000;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #00000030;
        border: 5px solid transparent;
        border-radius: 24px;
        box-shadow: 4px 0px 0px 4px #00000040 inset;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: #00000060;
        border: 0px solid transparent;
        box-shadow: none;
    }
}

.scrollbox2-horizontal {
    overflow-x: overlay !important;
    overflow-y: hidden !important;

    &::-webkit-scrollbar {
        display: block;
        width: 8px;
    }

    &::-webkit-scrollbar-button {
        display: none;
    }

    &::-webkit-scrollbar-track {
        background-color: #00000000;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: #00000000;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #00000030;
        border: 5px solid transparent;
        border-radius: 24px;
        box-shadow: 4px 0px 0px 4px #00000040 inset;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: #00000060;
        border: 0px solid transparent;
        box-shadow: none;
    }
}

.scrollbox2-full {
    overflow-x: overlay !important;
    overflow-y: overlay !important;

    &::-webkit-scrollbar {
        display: block;
        width: 8px;
    }

    &::-webkit-scrollbar-button {
        display: none;
    }

    &::-webkit-scrollbar-track {
        background-color: #00000000;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: #00000000;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #00000030;
        border: 5px solid transparent;
        border-radius: 24px;
        box-shadow: 4px 0px 0px 4px #00000040 inset;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: #00000060;
        border: 0px solid transparent;
        box-shadow: none;
    }
}

.dimmed {
    transition: 1s;
    opacity: 0.4;
}

.intrabooking-gray-background {
    background: #2b3848;
}
</style>
